import { Vec2, dist } from './vec';
import { EnemyState } from './enemy';

/**
 * How far an enemy still has to walk — the ranking every tower targets by,
 * because "first" means closest to breaking through. On a level with two
 * entrances (Nach'yo Business) the routes have different lengths, so raw
 * `distance` is not comparable between them and `remaining` is what counts.
 *
 * The fallback keeps hand-built EnemyStates (the unit tests') working: with no
 * `remaining`, ordering by `-distance` is exactly the old furthest-along rule,
 * which is the same answer whenever there is only one route.
 */
const toBase = (e: EnemyState): number => e.remaining ?? -e.distance;

export function selectTarget(
  towerPos: Vec2,
  range: number,
  enemies: EnemyState[],
): EnemyState | undefined {
  let best: EnemyState | undefined;
  for (const e of enemies) {
    if (!e.alive) continue;
    // Prince Nacho's second form is reachable from anywhere on the board (see
    // EnemySpec.ignoreRange) — every other enemy has to be inside `range`.
    if (!e.ignoreRange && dist(towerPos, e.pos) > range) continue;
    if (!best || toBase(e) < toBase(best)) best = e;
  }
  return best;
}

export function enemiesInRadius(center: Vec2, radius: number, enemies: EnemyState[]): EnemyState[] {
  return enemies.filter((e) => e.alive && dist(center, e.pos) <= radius);
}
